module.exports = __webpack_public_path__ + "img/mode1-3.0c2a93cb.png";